<template>
  <div v-if="config.filters.fields && config.filters.fields.length">
    <v-select
      v-for="filter in (config.filters.fields || [])"
      :key="filter"
      v-model="filters[filter]"
      :dense="windowWidth < 960"
      :disabled="loading"
      :label="label(filter)"
      :items="filtersValues[filter]"
      clearable
      multiple
      @input="refresh"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState(['dataset', 'loading', 'filtersValues']),
    ...mapGetters(['config', 'datasetUrl', 'fields']),
    filters: {
      set (val) { this.$store.state.filters = val },
      get () { return this.$store.state.filters }
    }
  },
  methods: {
    ...mapActions(['refresh']),
    label (key) {
      const field = this.fields[key]
      if (!field) return key
      return field.title || field['x-originalName'] || key
    }
  }
}
</script>
